var render = function render(){var _vm=this,_c=_vm._self._c;return _c('update-base',{attrs:{"stakeholder_type":_vm.relatedMerchantType.WALLET}},[(_vm.is_data_ready)?_c('update-form',{attrs:{"on_submit":_vm.update,"form_data":_vm.form_data,"form_meta_data":_vm.form_meta_data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }